import React from 'react';

import * as S from './BackButton.styles';

const BackButton = ({ onBackPress, text = 'BACK', arrow }) => {
    return (
        <S.BackBtn arrow={arrow} onClick={onBackPress}>{text}</S.BackBtn>
    )
}

export default BackButton;